// AppDetail.js
import React from 'react';
import { useParams } from 'react-router-dom';

export default function AppDetail() {
  const { appName } = useParams();

  const appData = {
    // Live Play Store Apps convert unit
    'happy-stack-tower': {
      title: 'Happy Stack Tower',
      images: [
        '/assets/img/app portfolio/happy-stack-tower-home-screen.webp',
        '/assets/img/app portfolio/happy-stack-tower-gameplay-screen.webp',
        '/assets/img/app portfolio/happy-stack-tower-level-selection.webp',
        '/assets/img/app portfolio/happy-stack-tower-score-screen.webp',
      ],
      apkLink: '/assets/apk/happy-stack-tower.apk',
      about: 'A fun and addictive stacking game! Build the tallest tower, unlock new themes, beat your high score, and enjoy smooth gameplay with beautiful graphics.',
    },
    'wallnex': {
      title: 'WallNex - HD Wallpapers',
      images: [
        '/assets/img/app portfolio/wallnex-hd-wallpapers-home-screen.webp',
        '/assets/img/app portfolio/wallnex-hd-wallpapers-category-list.webp',
        '/assets/img/app portfolio/wallnex-hd-wallpapers-preview-screen.webp',
        '/assets/img/app portfolio/wallnex-hd-wallpapers-download-option.webp',
      ],
      apkLink: '/assets/apk/wallnex.apk',
      about: 'Thousands of high-quality 4K & HD wallpapers updated daily. Categories: Nature, Abstract, Cars, Anime, Minimal, Dark, and more. Set wallpaper with one tap!',
    },
    'scan2pdf': {
      title: 'Scan2PDF - Document Scanner',
      images: [
        '/assets/img/app portfolio/scan2pdf-document-scan-screen-technicmentors.webp',
        '/assets/img/app portfolio/scan2pdf-auto-crop-feature-technicmentors.webp',
        '/assets/img/app portfolio/scan2pdf-ocr-text-recognition-technicmentors.webp',
        '/assets/img/app portfolio/scan2pdf-pdf-export-options-technicmentors.webp',
      ],
      apkLink: '/assets/apk/scan2pdf.apk',
      about: 'Professional document scanner in your pocket. Scan receipts, notes, IDs, and documents. Auto-crop, enhance, OCR text recognition, and export as PDF or JPG.',
    },
    'convert-units': {
      title: 'Convert Units',
      images: [
        '/assets/img/app portfolio/convert-units-home-screen-technicmentors.webp',
        '/assets/img/app portfolio/convert-units-category-selection-technicmentors.webp',
        '/assets/img/app portfolio/convert-units-conversion-result-technicmentors.webp',
        '/assets/img/app portfolio/convert-units-settings-screen-technicmentors.webp',
      ],
      apkLink: '/assets/apk/convert-units.apk',
      about: 'The ultimate all-in-one unit converter. Supports length, weight, temperature, currency, volume, speed, area, time, data, and 50+ categories. Offline & accurate.',
    },
    'tafheem-audio': {
      title: 'Tafheem Audio',
      images: [
        '/assets/img/app portfolio/tafheem-audio-quran-recitation-screen-technicmentors.webp',
        '/assets/img/app portfolio/tafheem-audio-surah-list-technicmentors.webp',
        '/assets/img/app portfolio/tafheem-audio-player-screen-technicmentors.webp',
        '/assets/img/app portfolio/tafheem-audio-offline-download-technicmentors.webp',
      ],
      apkLink: '/assets/apk/tafheem-audio.apk',
      about: 'Complete audio recitation of the Holy Quran with Urdu translation and explanation by Maulana Abul Ala Maududi (Tafheem-ul-Quran). Multiple reciters, offline listening.',
    },
    'maududi-books': {
      title: 'Maududi Books Collection',
      images: [
        '/assets/img/app portfolio/maududi-books-library-home-technicmentors.png',
        '/assets/img/app portfolio/maududi-books-book-list-technicmentors.png',
        '/assets/img/app portfolio/maududi-books-reading-screen-technicmentors.png',
        '/assets/img/app portfolio/maududi-books-search-feature-technicmentors.png',
      ],
      apkLink: '#', // iOS only or no APK
      about: 'Digital library of Islamic books by Maulana Syed Abul Ala Maududi. Includes Tafheem-ul-Quran, Tafseer, Seerat, and many other authentic Islamic writings.',
    },

    // Your Internal / Client Apps
    'capobrain': {
      title: 'CapoBrain',
      images: [
        '/assets/img/app portfolio/capobrain-school-dashboard-technicmentors.jpg',
        '/assets/img/app portfolio/capobrain-student-management-technicmentors.jpg',
        '/assets/img/app portfolio/capobrain-attendance-module-technicmentors.jpg',
        '/assets/img/app portfolio/capobrain-fees-management-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/capobrain.apk',
      about: 'Complete school management system for parents, teachers & admins. Attendance, results, fees, homework, announcements, and live communication.',
    },
    'capobiz': {
      title: 'CapoBiz',
      images: [
        '/assets/img/app portfolio/capobiz-erp-dashboard-technicmentors.jpg',
        '/assets/img/app portfolio/capobiz-inventory-management-technicmentors.jpg',
        '/assets/img/app portfolio/capobiz-sales-reporting-technicmentors.jpg',
        '/assets/img/app portfolio/capobiz-expense-tracking-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/capobiz.apk',
      about: 'Mini ERP for small businesses. Manage inventory, sales, purchases, expenses, customers, suppliers, and generate reports easily.',
    },
    'brainy-kids': {
      title: 'Brainy Kids',
      images: [
        '/assets/img/app portfolio/brainy-kids-learning-home-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-alphabet-module-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-games-screen-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-progress-tracking-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/brainy-kids.apk',
      about: 'Educational app for kids aged 3–8. Learn ABC, numbers, colors, shapes, animals, and logic through interactive games and activities.',
    },
    'tourist-guide': {
      title: 'Tourist Guide',
      images: [
        '/assets/img/app portfolio/tourist-guide-home-screen-technicmentors.jpg',
        '/assets/img/app portfolio/tourist-guide-attractions-list-technicmentors.jpg',
        '/assets/img/app portfolio/tourist-guide-map-navigation-technicmentors.jpg',
        '/assets/img/app portfolio/tourist-guide-hotel-search-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/tourist-guide.apk',
      about: 'Your personal travel guide with maps, attractions, hotels, restaurants, weather, and insider tips for tourists in Pakistan and beyond.',
    },
    'warrenty-app': {
      title: 'Warranty App',
      images: [
        '/assets/img/app portfolio/warranty-app-dashboard-technicmentors.jpg',
        '/assets/img/app portfolio/warranty-app-add-product-technicmentors.jpg',
        '/assets/img/app portfolio/warranty-app-expiry-reminder-technicmentors.jpg',
        '/assets/img/app portfolio/warranty-app-receipt-upload-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/warrenty-app.apk',
      about: 'Never miss a warranty expiry again! Track products, upload receipts, set reminders, and manage all your warranties in one secure place.',
    },
    'little-genious': {
      title: 'Little Genious',
      images: [
        '/assets/img/app portfolio/little-genius-learning-home-technicmentors.jpg',
        '/assets/img/app portfolio/little-genius-brain-games-technicmentors.jpg',
        '/assets/img/app portfolio/little-genius-drawing-activity-technicmentors.jpg',
        '/assets/img/app portfolio/little-genius-memory-training-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/little-genious.apk',
      about: 'Boost creativity and intelligence in children with puzzles, drawing, memory games, storytelling, and brain-training activities.',
    },
    'kids-learning': {
      title: 'Kids Learning',
      images: [
        '/assets/img/app portfolio/brainy-kids-alphabet-module-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-learning-home-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-games-screen-technicmentors.jpg',
        '/assets/img/app portfolio/brainy-kids-progress-tracking-technicmentors.jpg',
      ],
      apkLink: '/assets/apk/kids-learning.apk',
      about: 'Fun learning app with animated lessons on alphabet, phonics, numbers, math, science, and general knowledge for preschool kids.',
    },
  };

  const currentApp = appData[appName] || {
    title: 'App Not Found',
    images: [],
    apkLink: '#',
    about: 'No information available.',
  };

  return (
    <div>
      {/* Hero Header */}
      <div className="home-container">
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
                {currentApp.title}
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Detail Section */}
      <section className="app-detail-section mt-4" style={{ backgroundColor: "#f1f3fe" }}>
        <div className="container mt-4">
          {/* About App - Now at Top */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <h1 className="text-center mb-4">About This App</h1>
              <p className="lead text-muted text-center mb-0" style={{ lineHeight: '1.8', fontSize: '1.1rem' }}>
                {currentApp.about}
              </p>
            </div>
          </div>

          {/* Screenshots */}
            
          <div className="row g-4">
            {currentApp.images.map((src, i) => (
              <div key={i} className="col-12 col-sm-6 col-md-3">
                <img
                  src={src}
                  alt={`${currentApp.title} screenshot ${i + 1}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '18px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                    border: '1px solid #e0e0e0',
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}